import React, { useEffect, useState } from "react"
import { CloseButton, LocalShadow, PopupButton, PopupWrapper } from "../../../../components/styled/BasicBlocks"
import { IAnalysisFolder } from "./IAnalysisFolder";
import "./FullAnalysisFolderSettings.css";
import { FOLDER_ICONS, getFolderIconByIndex } from "../../../../utils/folderIcons";

interface IFullAnalysisFolderSettingsProps{
    folder: IAnalysisFolder,
    editableOptions?: {
        icon?: boolean,
        name?: boolean
    }
    onClose: ()=>void;
    onSubmit: (data: Partial<IAnalysisFolder>)=>void;
}

export const FullAnalysisFolderSettings = ({folder, editableOptions, onClose, onSubmit}: IFullAnalysisFolderSettingsProps) => {
    const [selectedIconIndex, setSelectedIconIndex] = useState<number>(0);
    const [fileName, setFileName] = useState<string>();
    const defaultAvailable = {icon: true, name: true};

    const options = editableOptions ? {...defaultAvailable, ...editableOptions} : defaultAvailable;

    useEffect(()=>{
        setSelectedIconIndex(folder.iconIndex || 0);
        setFileName(folder.name);
    }, [folder.iconIndex, folder.name]);

    return <LocalShadow onContextMenu={(e)=>{e.stopPropagation()}}>
        <PopupWrapper>
            <div className="FullAnalysisFolderSettings_head">
                <div className="FullAnalysisFolderSettings_title">File settings</div>
                <CloseButton onClick={onClose}></CloseButton>
            </div>
            <div className="FullAnalysisFolderSettings_form">
                <div className="FullAnalysisFolderSettings_nameSection">
                    <span className="FullAnalysisFolderSettings_nameSection_title">Name: </span>
                    <input className="FullAnalysisFolderSettings_name" value={fileName} onChange={(e)=>setFileName(e.target.value)}></input>
                </div>
                {options.icon && <div className="FullAnalysisFolderSettings_iconsSection">
                    <div className="FullAnalysisFolderSettings_iconsSection_title">Icon: </div>
                    <div className="FullAnalysisFolderSettings_icons">
                        {FOLDER_ICONS.map((iconUrl, index) => {
                            return <div 
                                key={index}
                                className={`FullAnalysisFolderSettings_icon ${index === selectedIconIndex ? 'FullAnalysisFolderSettings_icon--active': ''}`}
                                style={{backgroundImage: `url(${iconUrl})`}}
                                onClick={()=>{
                                    setSelectedIconIndex(index);
                                }}
                            ></div>
                        })}
                    </div>
                </div>}
            </div>
            <div className="FullAnalysisFolderSettings_buttons">
                <PopupButton onClick={()=>onSubmit({name: fileName, iconIndex: selectedIconIndex})}>Save</PopupButton>
            </div>
        </PopupWrapper>
    </LocalShadow>
}